import { c as _c } from "react/compiler-runtime";
import { classNames, TableHeader, TableHeaderCell } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
import { MINT_FEED_TABLE_COLUMN_CLASSNAMES } from "@/components/collection/drops/constants";
import { topStickyVariants } from "@/styles/utils/sticky";
export function MintFeedTableHeader() {
  const $ = _c(22);
  const t = useTranslations("MintFeedTableHeader");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = classNames(topStickyVariants({
      tableHeader: true
    }), "!top-0");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("minter");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <TableHeaderCell className={MINT_FEED_TABLE_COLUMN_CLASSNAMES.item}>{t1}</TableHeaderCell>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("price");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <TableHeaderCell className={MINT_FEED_TABLE_COLUMN_CLASSNAMES.price}>{t3}</TableHeaderCell>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("quantity");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <TableHeaderCell className={MINT_FEED_TABLE_COLUMN_CLASSNAMES.quantity}>{t5}</TableHeaderCell>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("time");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = <TableHeaderCell className={MINT_FEED_TABLE_COLUMN_CLASSNAMES.timestamp}>{t7}</TableHeaderCell>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t2 || $[18] !== t4 || $[19] !== t6 || $[20] !== t8) {
    t9 = <TableHeader className={t0}>{t2}{t4}{t6}{t8}</TableHeader>;
    $[17] = t2;
    $[18] = t4;
    $[19] = t6;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}